import React from "react"
import {
  SubText,
  Text,
  BetBlock,
  AutoPilot,
  BetAmountContainer,
  BetAmountWrapper,
  BetAmount,
  Operations,
  Operation,
  BetButton,
  BetBlockWrapper,
} from "../GameRulesStyles"

export default function PlaceBet() {
  return (
    <>
      <Text className={"big red"} margin={"0 0 10px"}>
        How To place a bet?
      </Text>
      <Text className={"big white"} margin={"0 0 10px"}>
        ENTER AN AMOUNT VIA INPUT AND SIMPLY CLICK ON{" "}
        <SubText className={"blue"}>BET BUTTON</SubText>
      </Text>
      <Text className={"small white"} margin={"0 0 4px"}>
        *TWO BETS CAN BE PLACED IN SAME ROUND WITH DIFFERENT AMOUNTS using 2nd
        SECTION
      </Text>
      <Text className={"small white"} margin={"0 0 4px"}>
        *AMOUNT CAN BE CONTROLLED BY ADDITIONAL{" "}
        <SubText className={"blue"}>1/2</SubText> and
        <SubText className={"red"}> 2x</SubText>
      </Text>
      <Text className={"small white"} margin={"0 0 10px"}>
        *YOU CAN
        <SubText className={"red"}> Cancel</SubText> YOUR BET JUST BEFORE NEXT
        ROUND STARTS
      </Text>
      <BetBlockWrapper>
        <BetBlock>
          <AutoPilot>autopilot</AutoPilot>
          <BetAmountContainer>
            <BetAmountWrapper>
              <BetAmount>
                <p>bet amount</p>
                <span>$100.00</span>
              </BetAmount>
              <Operations>
                <Operation color={"blue"}>1/2</Operation>
                <Operation>2x</Operation>
              </Operations>
            </BetAmountWrapper>
            <BetButton color={"blue"}>Bet</BetButton>
          </BetAmountContainer>
        </BetBlock>
      </BetBlockWrapper>
    </>
  )
}
